import { getEncryptData } from "./hashData";

/**
 * SERVER ONLY — builds the `?products=…&coupon=…` query for the checkout link.
 *
 * PaddleCheckoutButton is a client component and used to build this itself, which
 * forced the AES key to be NEXT_PUBLIC_ and therefore public. The button now takes
 * the finished query string as `attributes.checkoutQuery`, so the key stays on the
 * server. Call this from the server component that renders the button.
 *
 * The payload keys and defaults below must stay byte-identical to what the button
 * used to encrypt — the checkout page decrypts this shape (see checkout/page.jsx),
 * and existing links already in the wild carry the old format.
 */
export const buildCheckoutQuery = (attributes = {}) => {
  const {
    inlinePurchase = false,
    bundle = false,
    paddleProductIds = [],
    bundleProductsIds = [],
    freemiusProducts = [],
    couponCode = "",
    lists = [],
    tags = [],
    proTags = [],
  } = attributes;

  // An inline purchase opens Paddle in an overlay; there is no checkout link.
  if (inlinePurchase) return "";

  return `?${new URLSearchParams({
    products: getEncryptData({
      bundle,
      paddleProductIds,
      bundleProductsIds,
      freemiusProducts,
      lists,
      tags,
      proTags,
    }),
    ...(couponCode ? { coupon: couponCode } : {}),
  }).toString()}`;
};
